import styled from 'styled-components';
import { colors, breakpoints } from '../../../styles/variables';

import { SSection, SSectionContent } from '../../layout/Section/styles';

export const NavbarSection = styled(SSection)`
    padding: 2.4rem 3rem ${
        ({ isSticky }) => isSticky ? '2.4rem' : '2.4rem'
    };

    background-color: ${
        ({ isSticky }) => isSticky ? colors.white : 'none'
    };

    position: ${
        ({ isSticky }) => isSticky ? 'fixed' : 'static'
    };

    top: 0;
    z-index: 10;
`;

export const NavbarSectionContent = styled(SSectionContent)`
    flex-direction: row;
    justify-content: space-between;
`;

export const LogoBox = styled.div`
    width: 298px;
    height: auto;
`;

export const SList = styled.ul`
    display: none;
    list-style: none;
    margin: 0;

    @media (min-width: ${ breakpoints.medium }) {
        display: flex;
    }
`;

export const SLink = styled.li`
    padding: .8rem 1.6rem;
    font-size: 1.4rem;
    font-family: 'Gilroy', sans-serif;
    font-weight: 800;
    margin: 0;
    cursor: pointer;
    color: ${ ({ isActive }) => isActive ? colors.paypoGreen500 : colors.black };

    &:hover {
        color: ${ colors.greenPersian };
    }
`;
